import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ICreateAndSendPassengersDataInput } from '../../../../../../interface/interfaces';

interface IInitialState {
    analyzerPassengerLoading: boolean;
    analyzerPassengerData: string;
    analyzerPassengerError: string;
}

const initialState: IInitialState = {
    analyzerPassengerLoading: false,
    analyzerPassengerData: '',
    analyzerPassengerError: '',
};

const createAndSendPassengersSlice = createSlice({
    name: 'createAndSendPassengers',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        analyzerPassengerPending: (state: IInitialState, action: PayloadAction<ICreateAndSendPassengersDataInput>) => {
            state.analyzerPassengerLoading = true;
            state.analyzerPassengerError = '';
        },

        analyzerPassengerFulfilled: (state: IInitialState, action: PayloadAction<string>) => {
            state.analyzerPassengerLoading = false;
            state.analyzerPassengerData = action.payload;
            state.analyzerPassengerError = '';
        },

        analyzerPassengerFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.analyzerPassengerLoading = false;
            state.analyzerPassengerData = '';
            state.analyzerPassengerError = action.payload;
        },

        clearAnalayzerPassenger: (state: IInitialState) => {
            state.analyzerPassengerLoading = false;
            state.analyzerPassengerData = '';
            state.analyzerPassengerError = '';
        }
    },
});

export default createAndSendPassengersSlice.reducer;
export const { analyzerPassengerPending, analyzerPassengerFulfilled, analyzerPassengerFailure, clearAnalayzerPassenger } = createAndSendPassengersSlice.actions;
